import { connect } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";

import { ApplicationState } from "../../../redux/ApplicationState";
import { resetStates } from "../../../actions/Common";
import { saveTabSessionStorageResp } from "../../../actions/TabSessionStorage";
import { TabData } from "../../../models/TabSessionStorage";
import RequestServices from "../components/RequestServices";
import { getCareTypes, getDisciplineList } from "../../../actions/Master";
import { getListResult } from "../../../utils";
import { SlotsPayload } from "../../../models/Referral";
import { getIsRetroDetails, getSlots } from "../../../actions/ReferralAction";

const mapStateToProps = ({
  masterCareTypeState,
  disciplineListState,
  loggedInUserState,
  informationState,
  patientInformationByIdState,
  memberInfoDataState,
  reAuthReferralDetailState,
  slotsState,
  isRetroDetailsState
}: ApplicationState) => ({
  masterCareTypeState: getListResult(masterCareTypeState.response),
  disciplineListState: disciplineListState.response,
  loggedInUserState: loggedInUserState.response,
  informationState: informationState.response,
  patientInformationByIdState: patientInformationByIdState.response,
  memberInfoDataState: memberInfoDataState.response,
  reAuthReferralDetailState: reAuthReferralDetailState.response,
  slotsState: slotsState.response,
  isRetroDetailsState : isRetroDetailsState.response,
});

const mapDispatchToProps = (
    dispatch: ThunkDispatch<ApplicationState, Record<string, never>, any>
) => {
    return {
      resetStates: (actionType: string, field?: string) => {
        dispatch(resetStates(actionType, field));
      },
      saveTabSessionStorage: (SessionData: TabData) => {
        dispatch(saveTabSessionStorageResp(SessionData));
      },
      getCareTypes: () => {
        dispatch(getCareTypes());
      },
      getDisciplineList: (eligibilityId: number, isPortal: boolean) => {
        dispatch(getDisciplineList(eligibilityId, isPortal, 1));
      },
      getSlots: (payload: SlotsPayload) => {
        dispatch(getSlots(payload));
      },
      getIsRetroDetails: (startOfCareDate: string, userSpecificReceivedDateTime: string) => {
        dispatch(getIsRetroDetails(startOfCareDate, userSpecificReceivedDateTime));
      },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestServices);